const UI = '[data-estudio-captura]';

export function esconderCromoCaptura(): HTMLElement[] {
  const nodos = [...document.querySelectorAll<HTMLElement>(UI)];
  for (const n of nodos) n.style.setProperty('display', 'none', 'important');
  return nodos;
}

export function restaurarCromoCaptura(nodos: HTMLElement[]) {
  for (const n of nodos) n.style.removeProperty('display');
}

function blobDeCanvas(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => {
      if (!b) reject(new Error('canvas vacío'));
      else resolve(b);
    }, 'image/png');
  });
}

export async function pedirPestana(): Promise<MediaStream> {
  const opts = {
    video: true,
    preferCurrentTab: true,
    selfBrowserSurface: 'include',
  } as DisplayMediaStreamOptions;
  return navigator.mediaDevices.getDisplayMedia(opts);
}

export async function capturarPestana(stream: MediaStream): Promise<Blob> {
  const pista = stream.getVideoTracks()[0];
  if (!pista || pista.readyState !== 'live') {
    throw new Error('La compartición de pestaña se ha cortado');
  }
  const video = document.createElement('video');
  video.muted = true;
  video.srcObject = stream;
  await video.play();
  if (video.readyState < 2) {
    await new Promise<void>((resolve, reject) => {
      video.onloadeddata = () => resolve();
      video.onerror = () => reject(new Error('No se pudo leer la pestaña'));
    });
  }
  const w = video.videoWidth || window.innerWidth;
  const h = video.videoHeight || window.innerHeight;
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas');
  ctx.drawImage(video, 0, 0, w, h);
  video.pause();
  video.srcObject = null;
  return blobDeCanvas(canvas);
}
